import moment from 'moment';
import 'moment-timezone';

/**
 * Decide whether the Post Lesson button should be disabled for an upcoming
 * event, given the lesson's wall-clock start string and the studio timezone.
 *
 * `isEventPassed` is `true` when the event has NOT yet started. The button is
 * disabled while we're waiting for the lesson to happen. The variable name is
 * inverted from the natural reading; it's preserved here to match the caller.
 *
 * @param lessonStr Lesson start as wall-clock time, e.g. "2026-04-29T19:15:00".
 * @param studioTimezone IANA zone name; pass empty string to use browser local.
 * @param now Optional reference for "current time" (mostly for tests).
 */
export function computeIsEventPassed(
  lessonStr: string,
  studioTimezone: string,
  now?: moment.Moment | Date | string,
): boolean {
  const eventStartDateTime = studioTimezone
    ? moment.tz(lessonStr, studioTimezone)
    : moment(lessonStr);
  const currentTime = now
    ? (studioTimezone ? moment.tz(now, studioTimezone) : moment(now))
    : (studioTimezone ? moment.tz(studioTimezone) : moment());

  return !eventStartDateTime.isBefore(currentTime);
}
